// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class ActualsMetrics {
  readonly quotedVolumeActiveMix: string | null;
  readonly quotedVolumeActiveAsphalt: string | null;
  readonly quotedVolumeActiveAggregate: string | null;
  readonly quotedVolumeCurrentMonthMix: string | null;
  readonly quotedVolumeCurrentMonthAsphalt: string | null;
  readonly quotedVolumeCurrentMonthAggregate: string | null;
  readonly quotedVolumePreviousMonthMix: string | null;
  readonly quotedVolumePreviousMonthAsphalt: string | null;
  readonly quotedVolumePreviousMonthAggregate: string | null;
  readonly quotedVolumeChangePercentageMix: string | null;
  readonly quotedVolumeChangePercentageAsphalt: string | null;
  readonly quotedVolumeChangePercentageAggregate: string | null;
  readonly forecastActiveMix: string | null;
  readonly forecastActiveAsphalt: string | null;
  readonly forecastActiveAggregate: string | null;
  readonly forecastCurrentMonthMix: string | null;
  readonly forecastCurrentMonthAsphalt: string | null;
  readonly forecastCurrentMonthAggregate: string | null;
  readonly forecastPreviousMonthMix: string | null;
  readonly forecastPreviousMonthAsphalt: string | null;
  readonly forecastPreviousMonthAggregate: string | null;
  readonly forecastChangePercentageMix: string | null;
  readonly forecastChangePercentageAsphalt: string | null;
  readonly forecastChangePercentageAggregate: string | null;
  readonly outstandingBacklogActiveMix: string | null;
  readonly outstandingBacklogActiveAsphalt: string | null;
  readonly outstandingBacklogActiveAggregate: string | null;
  readonly outstandingBacklogCurrentMonthMix: string | null;
  readonly outstandingBacklogCurrentMonthAsphalt: string | null;
  readonly outstandingBacklogCurrentMonthAggregate: string | null;
  readonly outstandingBacklogPreviousMonthMix: string | null;
  readonly outstandingBacklogPreviousMonthAsphalt: string | null;
  readonly outstandingBacklogPreviousMonthAggregate: string | null;
  readonly outstandingBacklogChangePercentageMix: string | null;
  readonly outstandingBacklogChangePercentageAsphalt: string | null;
  readonly outstandingBacklogChangePercentageAggregate: string | null;
  readonly actualCurrentMonthMix: string | null;
  readonly actualCurrentMonthAsphalt: string | null;
  readonly actualCurrentMonthAggregate: string | null;
  readonly actualPreviousMonthMix: string | null;
  readonly actualPreviousMonthAsphalt: string | null;
  readonly actualPreviousMonthAggregate: string | null;
  readonly actualChangePercentageMix: string | null;
  readonly actualChangePercentageAsphalt: string | null;
  readonly actualChangePercentageAggregate: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.quotedVolumeActiveMix =
      data.quotedVolumeActiveMix === undefined ? null : data.quotedVolumeActiveMix;
    this.quotedVolumeActiveAsphalt =
      data.quotedVolumeActiveAsphalt === undefined ? null : data.quotedVolumeActiveAsphalt;
    this.quotedVolumeActiveAggregate =
      data.quotedVolumeActiveAggregate === undefined ? null : data.quotedVolumeActiveAggregate;
    this.quotedVolumeCurrentMonthMix =
      data.quotedVolumeCurrentMonthMix === undefined ? null : data.quotedVolumeCurrentMonthMix;
    this.quotedVolumeCurrentMonthAsphalt =
      data.quotedVolumeCurrentMonthAsphalt === undefined
        ? null
        : data.quotedVolumeCurrentMonthAsphalt;
    this.quotedVolumeCurrentMonthAggregate =
      data.quotedVolumeCurrentMonthAggregate === undefined
        ? null
        : data.quotedVolumeCurrentMonthAggregate;
    this.quotedVolumePreviousMonthMix =
      data.quotedVolumePreviousMonthMix === undefined ? null : data.quotedVolumePreviousMonthMix;
    this.quotedVolumePreviousMonthAsphalt =
      data.quotedVolumePreviousMonthAsphalt === undefined
        ? null
        : data.quotedVolumePreviousMonthAsphalt;
    this.quotedVolumePreviousMonthAggregate =
      data.quotedVolumePreviousMonthAggregate === undefined
        ? null
        : data.quotedVolumePreviousMonthAggregate;
    this.quotedVolumeChangePercentageMix =
      data.quotedVolumeChangePercentageMix === undefined
        ? null
        : data.quotedVolumeChangePercentageMix;
    this.quotedVolumeChangePercentageAsphalt =
      data.quotedVolumeChangePercentageAsphalt === undefined
        ? null
        : data.quotedVolumeChangePercentageAsphalt;
    this.quotedVolumeChangePercentageAggregate =
      data.quotedVolumeChangePercentageAggregate === undefined
        ? null
        : data.quotedVolumeChangePercentageAggregate;
    this.forecastActiveMix = data.forecastActiveMix === undefined ? null : data.forecastActiveMix;
    this.forecastActiveAsphalt =
      data.forecastActiveAsphalt === undefined ? null : data.forecastActiveAsphalt;
    this.forecastActiveAggregate =
      data.forecastActiveAggregate === undefined ? null : data.forecastActiveAggregate;
    this.forecastCurrentMonthMix =
      data.forecastCurrentMonthMix === undefined ? null : data.forecastCurrentMonthMix;
    this.forecastCurrentMonthAsphalt =
      data.forecastCurrentMonthAsphalt === undefined ? null : data.forecastCurrentMonthAsphalt;
    this.forecastCurrentMonthAggregate =
      data.forecastCurrentMonthAggregate === undefined ? null : data.forecastCurrentMonthAggregate;
    this.forecastPreviousMonthMix =
      data.forecastPreviousMonthMix === undefined ? null : data.forecastPreviousMonthMix;
    this.forecastPreviousMonthAsphalt =
      data.forecastPreviousMonthAsphalt === undefined ? null : data.forecastPreviousMonthAsphalt;
    this.forecastPreviousMonthAggregate =
      data.forecastPreviousMonthAggregate === undefined
        ? null
        : data.forecastPreviousMonthAggregate;
    this.forecastChangePercentageMix =
      data.forecastChangePercentageMix === undefined ? null : data.forecastChangePercentageMix;
    this.forecastChangePercentageAsphalt =
      data.forecastChangePercentageAsphalt === undefined
        ? null
        : data.forecastChangePercentageAsphalt;
    this.forecastChangePercentageAggregate =
      data.forecastChangePercentageAggregate === undefined
        ? null
        : data.forecastChangePercentageAggregate;
    this.outstandingBacklogActiveMix =
      data.outstandingBacklogActiveMix === undefined ? null : data.outstandingBacklogActiveMix;
    this.outstandingBacklogActiveAsphalt =
      data.outstandingBacklogActiveAsphalt === undefined
        ? null
        : data.outstandingBacklogActiveAsphalt;
    this.outstandingBacklogActiveAggregate =
      data.outstandingBacklogActiveAggregate === undefined
        ? null
        : data.outstandingBacklogActiveAggregate;
    this.outstandingBacklogCurrentMonthMix =
      data.outstandingBacklogCurrentMonthMix === undefined
        ? null
        : data.outstandingBacklogCurrentMonthMix;
    this.outstandingBacklogCurrentMonthAsphalt =
      data.outstandingBacklogCurrentMonthAsphalt === undefined
        ? null
        : data.outstandingBacklogCurrentMonthAsphalt;
    this.outstandingBacklogCurrentMonthAggregate =
      data.outstandingBacklogCurrentMonthAggregate === undefined
        ? null
        : data.outstandingBacklogCurrentMonthAggregate;
    this.outstandingBacklogPreviousMonthMix =
      data.outstandingBacklogPreviousMonthMix === undefined
        ? null
        : data.outstandingBacklogPreviousMonthMix;
    this.outstandingBacklogPreviousMonthAsphalt =
      data.outstandingBacklogPreviousMonthAsphalt === undefined
        ? null
        : data.outstandingBacklogPreviousMonthAsphalt;
    this.outstandingBacklogPreviousMonthAggregate =
      data.outstandingBacklogPreviousMonthAggregate === undefined
        ? null
        : data.outstandingBacklogPreviousMonthAggregate;
    this.outstandingBacklogChangePercentageMix =
      data.outstandingBacklogChangePercentageMix === undefined
        ? null
        : data.outstandingBacklogChangePercentageMix;
    this.outstandingBacklogChangePercentageAsphalt =
      data.outstandingBacklogChangePercentageAsphalt === undefined
        ? null
        : data.outstandingBacklogChangePercentageAsphalt;
    this.outstandingBacklogChangePercentageAggregate =
      data.outstandingBacklogChangePercentageAggregate === undefined
        ? null
        : data.outstandingBacklogChangePercentageAggregate;
    this.actualCurrentMonthMix =
      data.actualCurrentMonthMix === undefined ? null : data.actualCurrentMonthMix;
    this.actualCurrentMonthAsphalt =
      data.actualCurrentMonthAsphalt === undefined ? null : data.actualCurrentMonthAsphalt;
    this.actualCurrentMonthAggregate =
      data.actualCurrentMonthAggregate === undefined ? null : data.actualCurrentMonthAggregate;
    this.actualPreviousMonthMix =
      data.actualPreviousMonthMix === undefined ? null : data.actualPreviousMonthMix;
    this.actualPreviousMonthAsphalt =
      data.actualPreviousMonthAsphalt === undefined ? null : data.actualPreviousMonthAsphalt;
    this.actualPreviousMonthAggregate =
      data.actualPreviousMonthAggregate === undefined ? null : data.actualPreviousMonthAggregate;
    this.actualChangePercentageMix =
      data.actualChangePercentageMix === undefined ? null : data.actualChangePercentageMix;
    this.actualChangePercentageAsphalt =
      data.actualChangePercentageAsphalt === undefined ? null : data.actualChangePercentageAsphalt;
    this.actualChangePercentageAggregate =
      data.actualChangePercentageAggregate === undefined
        ? null
        : data.actualChangePercentageAggregate;
  }

  static zero(): ActualsMetrics {
    const zeroValues: ExcludeMethodsDeep<ActualsMetrics> = {
      quotedVolumeActiveMix: null,
      quotedVolumeActiveAsphalt: null,
      quotedVolumeActiveAggregate: null,
      quotedVolumeCurrentMonthMix: null,
      quotedVolumeCurrentMonthAsphalt: null,
      quotedVolumeCurrentMonthAggregate: null,
      quotedVolumePreviousMonthMix: null,
      quotedVolumePreviousMonthAsphalt: null,
      quotedVolumePreviousMonthAggregate: null,
      quotedVolumeChangePercentageMix: null,
      quotedVolumeChangePercentageAsphalt: null,
      quotedVolumeChangePercentageAggregate: null,
      forecastActiveMix: null,
      forecastActiveAsphalt: null,
      forecastActiveAggregate: null,
      forecastCurrentMonthMix: null,
      forecastCurrentMonthAsphalt: null,
      forecastCurrentMonthAggregate: null,
      forecastPreviousMonthMix: null,
      forecastPreviousMonthAsphalt: null,
      forecastPreviousMonthAggregate: null,
      forecastChangePercentageMix: null,
      forecastChangePercentageAsphalt: null,
      forecastChangePercentageAggregate: null,
      outstandingBacklogActiveMix: null,
      outstandingBacklogActiveAsphalt: null,
      outstandingBacklogActiveAggregate: null,
      outstandingBacklogCurrentMonthMix: null,
      outstandingBacklogCurrentMonthAsphalt: null,
      outstandingBacklogCurrentMonthAggregate: null,
      outstandingBacklogPreviousMonthMix: null,
      outstandingBacklogPreviousMonthAsphalt: null,
      outstandingBacklogPreviousMonthAggregate: null,
      outstandingBacklogChangePercentageMix: null,
      outstandingBacklogChangePercentageAsphalt: null,
      outstandingBacklogChangePercentageAggregate: null,
      actualCurrentMonthMix: null,
      actualCurrentMonthAsphalt: null,
      actualCurrentMonthAggregate: null,
      actualPreviousMonthMix: null,
      actualPreviousMonthAsphalt: null,
      actualPreviousMonthAggregate: null,
      actualChangePercentageMix: null,
      actualChangePercentageAsphalt: null,
      actualChangePercentageAggregate: null,
    };
    return new ActualsMetrics(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ActualsMetricsWireFormat = {
  quotedVolumeActiveMix: string | null;
  quotedVolumeActiveAsphalt: string | null;
  quotedVolumeActiveAggregate: string | null;
  quotedVolumeCurrentMonthMix: string | null;
  quotedVolumeCurrentMonthAsphalt: string | null;
  quotedVolumeCurrentMonthAggregate: string | null;
  quotedVolumePreviousMonthMix: string | null;
  quotedVolumePreviousMonthAsphalt: string | null;
  quotedVolumePreviousMonthAggregate: string | null;
  quotedVolumeChangePercentageMix: string | null;
  quotedVolumeChangePercentageAsphalt: string | null;
  quotedVolumeChangePercentageAggregate: string | null;
  forecastActiveMix: string | null;
  forecastActiveAsphalt: string | null;
  forecastActiveAggregate: string | null;
  forecastCurrentMonthMix: string | null;
  forecastCurrentMonthAsphalt: string | null;
  forecastCurrentMonthAggregate: string | null;
  forecastPreviousMonthMix: string | null;
  forecastPreviousMonthAsphalt: string | null;
  forecastPreviousMonthAggregate: string | null;
  forecastChangePercentageMix: string | null;
  forecastChangePercentageAsphalt: string | null;
  forecastChangePercentageAggregate: string | null;
  outstandingBacklogActiveMix: string | null;
  outstandingBacklogActiveAsphalt: string | null;
  outstandingBacklogActiveAggregate: string | null;
  outstandingBacklogCurrentMonthMix: string | null;
  outstandingBacklogCurrentMonthAsphalt: string | null;
  outstandingBacklogCurrentMonthAggregate: string | null;
  outstandingBacklogPreviousMonthMix: string | null;
  outstandingBacklogPreviousMonthAsphalt: string | null;
  outstandingBacklogPreviousMonthAggregate: string | null;
  outstandingBacklogChangePercentageMix: string | null;
  outstandingBacklogChangePercentageAsphalt: string | null;
  outstandingBacklogChangePercentageAggregate: string | null;
  actualCurrentMonthMix: string | null;
  actualCurrentMonthAsphalt: string | null;
  actualCurrentMonthAggregate: string | null;
  actualPreviousMonthMix: string | null;
  actualPreviousMonthAsphalt: string | null;
  actualPreviousMonthAggregate: string | null;
  actualChangePercentageMix: string | null;
  actualChangePercentageAsphalt: string | null;
  actualChangePercentageAggregate: string | null;
};

type NewActualsMetricsProps = PartialDeep<ActualsMetrics, { recurseIntoArrays: true }>;
export const NewActualsMetrics: (props: NewActualsMetricsProps) => ActualsMetrics = (props) =>
  new ActualsMetrics(props);

type NewActualsMetricsFromWireFormatProps = PartialDeep<
  ActualsMetricsWireFormat,
  { recurseIntoArrays: true }
>;
export const NewActualsMetricsFromWireFormat: (
  props: NewActualsMetricsFromWireFormatProps,
) => ActualsMetrics = (props) => new ActualsMetrics(props);
